
import { apiRequest } from "./ApiUtility";

export async function getAppointments(authContext, filters) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/visit/facility/${authContext?.selectedFacility?.id}`;
 
  return await apiRequest("post", url, authContext, filters);
}

export async function getAppointment(authContext, appointmentId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/appointment/${appointmentId}`;
  // Create a modified authContext for this specific call
  const modifiedAuthContext = {
    ...authContext,
    authToken: authContext.auth.authToken
  };
  return await apiRequest("get", url, modifiedAuthContext);
}

export async function getAvailableSlots(dates, authContext, physicianId, serviceId) {
  if (!dates || !authContext || !physicianId) {
    return { isSuccess: false, data: {} };
  }
  
  const url = "/api/providedservices/availableslots";
  const data = {
    physicianId: physicianId,
    dates: dates,
    serviceId: serviceId,
  };
  
  const result = await apiRequest("post", url, authContext, data);
  // Preserve the original logic for result.isSuccess
  if (result.isSuccess) {
    result.isSuccess = result.data ? true : false;
  }
  return result;
}

export async function createNewAppointment(authContext, patientId, physicianId, appointmentDateTime, patientNotes, clinicalServiceId) {
  const url = "/api/appointment";
  const data = {
    patientId: patientId,
    physicianId: physicianId,
    appointmentDateTime: appointmentDateTime,
    notes: patientNotes,
    clinicalServiceId: clinicalServiceId,
    facilityId: authContext.selectedFacility.id
  };
  return await apiRequest("post", url, authContext, data);
}

export async function updateAppointmentStatus(authContext, appointmentId, newStatus) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/visit/updatestatus/${appointmentId}`;
  const data = {
    newStatus: newStatus,
    facilityId: authContext.selectedFacility.id,
  };
  return await apiRequest("put", url, authContext, data);
}
